import React from 'react'
import { ToggleButtonGroupProps } from './types'
import { ToggleButton } from './components/ToggleButton'
import styles from './styles.module.scss'

export const ToggleButtonGroup = ({
  onChange,
  initialValue = '',
  items,
}: ToggleButtonGroupProps) => {
  const handleClick = (value: string) => {
    onChange?.(value)
  }

  return (
    <div className={styles.group}>
      {Object.entries(items).map(([key, value]) => (
        <ToggleButton
          value={value}
          key={value}
          onClick={handleClick}
          selected={initialValue === value}
        >
          {key}
        </ToggleButton>
      ))}
    </div>
  )
}
